import { render, staticRenderFns } from "./PatientSummaryCard.vue?vue&type=template&id=3513e99a&functional=true&"
import script from "./PatientSummaryCard.vue?vue&type=script&lang=js&"
export * from "./PatientSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports